<template lang="pug">
  .block-no-prizes
    .error
      i.icon.error__icon
      h2.block-no-prizes__title {{ $t('promo.prizes.no_presents.title') }}

    .block-no-prizes__text {{ $t('promo.prizes.no_presents.text') }}

</template>

<script>
export default {
  name: "BlockNoPrizes",
};
</script>
